module.exports = __webpack_public_path__ + "img/default_profile.b3405a37.svg";